import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpProposalDetailPage } from '@/features/pcmp/pages/PcmpProposalDetailPage';

export const Route = createFileRoute('/_auth/pcmp/proposals/$proposalId/')({
  parseParams: ({ proposalId }) => {
    const parsedId = Number(proposalId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { proposalId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Proposal">
      <PcmpProposalDetailPage />
    </ErrorBoundary>
  ),
});
